<template>
  <p-edit />
</template>

<script>
import Edit from './../components/reports/EditReport.vue';

export default {
  components: {
    'p-edit': Edit
  }
};
</script>
